import React, { useState, useEffect } from 'react';
import { timeDelta } from '../utils';

const CountdownTimer = ({ expiresAt, className = "timer" }) => {
  const [timeLeft, setTimeLeft] = useState(0);

  useEffect(() => {
    if (!expiresAt) return;

    const targetTime = new Date(expiresAt).getTime();
    
    const updateTimer = () => {
      const now = Date.now();
      const remaining = Math.max(0, targetTime - now);
      setTimeLeft(remaining);
    };

    updateTimer(); // Initial update
    const interval = setInterval(updateTimer, 1000); // Keep 1s interval for accurate expiry

    return () => clearInterval(interval);
  }, [expiresAt]);

  if (!expiresAt) {
    return <span className={`${className} no-timer`}>-</span>;
  }

  if (timeLeft <= 0) {
    return <span className={`${className} expired`}>-</span>;
  }

  const timeComponents = timeDelta(Date.now() + timeLeft, Date.now());
  let { days, hours, minutes } = timeComponents; // Seconds are no longer needed here for display

  const totalHours = days * 24 + hours;

  const formatTime = () => {
    if (totalHours > 0) {
      return `${totalHours}h ${minutes}m`;
    } else if (minutes > 0) {
      return `${minutes}m`;
    } else {
      return `1m`; 
    }
  };

  // Simplified class determination: all non-expired, valid timers are considered 'active' for styling
  const getTimerClass = () => {
    // No special classes for urgent or warning, just one 'active' class for styling
    return `${className} active`; 
  };

  return (
    <span className={getTimerClass()}>
      {formatTime()}
    </span>
  );
};

export default CountdownTimer; 